import { useDispatch, useSelector } from 'react-redux';
import { getBranchListAction } from '../actions/job-action/branch.action';
import { searchJobListAction } from '../actions/job-action/search.action';
import { crewActions } from '../reducers/crews.reducer';
import { jobAction } from '../reducers/jobs.reducer';
import { AppDispatch } from '../store';
import { JobsState, RootState } from '../types/store.types';

export const useAmsStore = () => {
  const jobStore = useSelector<RootState, JobsState>((state) => state.jobs);
  const dispatch = useDispatch<AppDispatch>();

  const {
    addJobs,
    moveTypes,
    updateCurrentBranch,
    toggleSwitch,
    addJobsWarning,
    addCrewCardWarning,
    updateCalenderDate,
    toggleAccessibility,
    clearSearchResult,
    toggleCustomerInfoDrawer,
    toggleCrewBuilderDrawer,
    toggleCrewBuilderModal,
    handleBranchUpdate,
    handleUpdateJobsWithCrew,
    handleUpdateJobsWithCrewJunk,
    getJunkStatistics,
    handleUpdateDraggedJobsWithCrew,
    handleUpdateUniqueCrewBuilderGroups,
    handleDragJobId,
    handleDragJobServiceType,
    handleUpdateUnscheduledJobs,
    handleUpdateCustomerDetail,
    handleSaveJobID,
    clearFilter,
    filterJobList,
    handleFetchAllConfirmJobList,
    openModalAfterSave,
    handleUpdateCustomerInfo,
    handleCustomerInfoDetailsChange,
    handleJobBookedDate,
    handleDragJobSlot,
    fetchCustomerInfoDetails,
    fetchLabortimesCustomerInfoDetails,
    handleSaveModalOpen,
    fetchMaterialsItemsData,
    fetchLaborTimesData,
    handleJunkCheckboxValues,
    handleFvpCheckboxValues,
    handleClearCheckBox,
    fetchJunkInfoData,
    updateLaborTimesData,
    fetchPaymentSummaryData,
    fetchPaymentFormData,
    fetchPaymentHistoryData,
    fetchPaymentDates,
    fetchSelectIndex,
    fetchInvoiceDetailsData,
    initiatePayment,
    initiateRefund,
    handleBranchJobStats,
    addCustomerInfoForPayment,
    fetchInvoiceDetailsSummaryData,
    createNewUnblockJobs,
    fetchInvoiceDetailsDataJunk,
    fetchSelectJob,
  } = jobAction;
  const { updateDriverList, updateHelperList, updateTruckList } = crewActions;

  return {
    addJobs,
    moveTypes,
    jobStore,
    updateCurrentBranch,
    toggleSwitch,
    addJobsWarning,
    addCrewCardWarning,
    updateCalenderDate,
    toggleAccessibility,
    dispatch,
    searchJobListAction,
    clearSearchResult,
    toggleCustomerInfoDrawer,
    toggleCrewBuilderDrawer,
    toggleCrewBuilderModal,
    getBranchListAction,
    handleBranchUpdate,
    handleUpdateJobsWithCrew,
    handleUpdateJobsWithCrewJunk,
    handleDragJobSlot,
    getJunkStatistics,
    handleUpdateDraggedJobsWithCrew,
    handleUpdateUniqueCrewBuilderGroups,
    handleDragJobId,
    handleDragJobServiceType,
    handleJobBookedDate,
    handleUpdateUnscheduledJobs,
    handleUpdateCustomerDetail,
    handleSaveJobID,
    updateDriverList,
    updateHelperList,
    updateTruckList,
    clearFilter,
    filterJobList,
    handleFetchAllConfirmJobList,
    openModalAfterSave,
    handleUpdateCustomerInfo,
    handleCustomerInfoDetailsChange,
    fetchCustomerInfoDetails,
    fetchLabortimesCustomerInfoDetails,
    handleSaveModalOpen,
    fetchMaterialsItemsData,
    fetchLaborTimesData,
    updateLaborTimesData,
    handleJunkCheckboxValues,
    handleFvpCheckboxValues,
    handleClearCheckBox,
    fetchJunkInfoData,
    fetchPaymentSummaryData,
    fetchPaymentFormData,
    fetchPaymentHistoryData,
    fetchPaymentDates,
    fetchSelectIndex,
    fetchInvoiceDetailsData,
    initiatePayment,
    initiateRefund,
    handleBranchJobStats,
    addCustomerInfoForPayment,
    fetchInvoiceDetailsSummaryData,
    createNewUnblockJobs,
    fetchInvoiceDetailsDataJunk,
    fetchSelectJob,
  };
};
